import React, { useState, useEffect } from "react"
import _ from 'lodash'
import { field_attrs } from "components/table/lib/column-field"

import { DropdownInput, NumberInput } from "components/table/carousel/inputs"

import YearValues from "components/line-items/controls/year-values"
import getEmptyYears, { Year } from "components/line-items/lib/get-empty-years"

import propertyService from "data/property"
import notificationService from "data/notification"

import { HorizontalHeader_s } from "components/line-items/controls/line-item-carousel-styles"

const ADRDetailedMonthly = (props: {rowData: [], field: string, namedItems: {}, persist: Function, defaults: object}) => {
  const initialItems: Year[] = _.get(props.rowData[props.field], "items")
  const [data, setData] = useState<object|null>(props.rowData[props.field])
  const [yearData, setYearData] = useState<Year[]>(initialItems && initialItems.length ? initialItems : getEmptyYears(2, 0))
  const [years, setYears] = useState<number>(initialItems && initialItems.length ? initialItems.length : 2)
  const [yearsLimit, setYearsLimit] = useState<number>(36)
  const [none, setNone] = useState<boolean>(false)

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field].state !== 'detailedMo') {
      setYears(2)
      setYearData(getEmptyYears(2, 0))
      setData({inflation: props.defaults['adrInflation']});
      setNone(true)
    }
  }, [props['rowData']])

  useEffect(() => {
    if(none === true) setNone(false)
  }, [none])

  useEffect(() => {
    let property = propertyService.get()
    if(property) {
      if(property.term && property.term >= 1 && (property.term + 2) <= 37) {
        setYearsLimit(property.term + 2)
      } else {
        setYearsLimit(37)
      }
    }
  }, [])

  function updateData(val): void {
    const newData = _.cloneDeep(data || {})
    setYearData(val)
    if (!_(yearData).differenceWith(val, _.isEqual).isEmpty()){
      props.persist({dateMode: "relative", state: "detailedMo", items: val, inflation: newData['inflation']}, props.field, props.rowData)
    }
  }

  function updateInflation(val): void {
    const newData = _.cloneDeep(data || {})
    const inflation = {
      inflationMode: "namedItem",
      inflationNamedItemId: val
    }
    _.set(newData, 'inflation', inflation);
    setData(newData);
    props.persist({
      dateMode: "relative",
      state: "detailedMo",
      items: yearData,
      inflation,
    }, props.field, props.rowData)
  }

  function handleYearsBlur(newYears) {
    const parsedYears = parseInt(newYears)
    if(!isNaN(parsedYears)) {
      if(parsedYears >= 1 && parsedYears <= yearsLimit) {
        changeYearDataLength(parsedYears)
      } else if (parsedYears < 1) {
        changeYearDataLength(1)
        notificationService.notify({
          type: "warn",
          message: "Years must be set to at least 1.",
          dismiss: 4000
        })
      } else if (parsedYears > yearsLimit) {
        changeYearDataLength(yearsLimit)
        notificationService.notify({
          type: "warn",
          message: `Years cannot be greater than the property term plus two years.  The limit is currently ${yearsLimit} years.`,
          dismiss: 4000
        })
      }
    } else {
      setYears(parsedYears)
    }
  }

  function changeYearDataLength(numberOfYears) {
    // add or remove year columns if the totalYears param changes
    let updatedYearData: Year[] = yearData
    if(numberOfYears > updatedYearData.length) {
      const diff = numberOfYears - updatedYearData.length
      const empties = getEmptyYears(diff, updatedYearData.length)
      updatedYearData = updatedYearData.concat(empties)
    } else if(numberOfYears < updatedYearData.length) {
      updatedYearData = updatedYearData.slice(0, numberOfYears)
    }
    setYearData(updatedYearData)
    setYears(numberOfYears)
    updateData(updatedYearData)
  }

  const attrs = (field) => field_attrs('room', `adrdetail`)(field)(props.rowData, props)
  const item_attrs = (field) => field_attrs('room', `adrdetail.items`)(field)(props.rowData, props)
  const infl_attrs = (field) => field_attrs('room', 'adrdetail')(field, (e) => _(e.path).take(2).isEqual(['adrdetail', 'inflation']))(props.rowData, props)

  const inflationOptions = _.map(
    _.get(props, "namedItems.inflation"),
    item => {
      return {value: item.inflationid, label: item.code}
    }
  )

  return (
    <div>
      <HorizontalHeader_s>
        <div>
          <label>Years of Detailed Input</label>
          <NumberInput className="automated years-input" data={{years}} field="years" readPrecision={0} writePrecision={0} persist={handleYearsBlur} />
        </div>
        <div>
          <label>Inflation</label>
          <DropdownInput className="automated" data={data} attrs={infl_attrs} field="inflation.inflationNamedItemId" options={inflationOptions} persist={updateInflation} />
        </div>
      </HorizontalHeader_s>
      <YearValues
        allYearsData={yearData}
        handleUpdate={(data) => updateData(data)}
        isPercent={true}
        lastFieldTabHandler={() => {}}
        shiftTabTarget={document}
        none={none}
        reset={() => {}}
        attrs={item_attrs}
      />
    </div>
  )
}

export default ADRDetailedMonthly
